import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { 
  FaHome, 
  FaSearch, 
  FaUser, 
  FaSignOutAlt, 
  FaChalkboardTeacher, 
  FaBars, 
  FaTimes, 
  FaInfoCircle, 
  FaEnvelope 
} from 'react-icons/fa';
import { useAuth } from '../../contexts/AuthContext';
import { signOut } from 'firebase/auth';
import { auth } from '../../firebase/config';

const Navbar = () => {
  const { user, userData } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate('/login');
      setIsMenuOpen(false);
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Check if current path is active
  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <header className="navbar">
      <div className="container">
        <Link to="/" className="logo">
          <div className="logo-container">
            <img 
              src="https://t3.ftcdn.net/jpg/03/54/50/64/360_F_354506479_eQUbTaxZM6Fh3R02xyRFnwmEXKZcCOMg.jpg" 
              alt="Tutor Connect Logo" 
              className="logo-image"
            />
            <div className="logo-text">
              <span className="logo-main">Tutor Connect</span>
              <span className="logo-subtitle">Cameroon</span>
            </div>
          </div>
        </Link>
        
        <button 
          className="mobile-menu-btn" 
          onClick={toggleMenu}
          aria-label={isMenuOpen ? "Close menu" : "Open menu"}
        >
          {isMenuOpen ? <FaTimes /> : <FaBars />}
        </button>
        
        <nav className={`nav-links ${isMenuOpen ? 'active' : ''}`}>
          <ul className="nav-list">
            <li>
              <Link 
                to="/" 
                className={`nav-link ${isActive('/') ? 'active' : ''}`}
                onClick={() => setIsMenuOpen(false)}
              >
                <FaHome className="nav-icon" /> 
                <span className="nav-text">Home</span>
              </Link>
            </li>
            <li>
              <Link 
                to="/search" 
                className={`nav-link ${isActive('/search') ? 'active' : ''}`}
                onClick={() => setIsMenuOpen(false)}
              >
                <FaSearch className="nav-icon" /> 
                <span className="nav-text">Find Tutors</span>
              </Link>
            </li>
            <li>
              <Link 
                to="/about" 
                className={`nav-link ${isActive('/about') ? 'active' : ''}`}
                onClick={() => setIsMenuOpen(false)}
              >
                <FaInfoCircle className="nav-icon" /> 
                <span className="nav-text">About Us</span>
              </Link>
            </li>
            <li>
              <Link 
                to="/contact" 
                className={`nav-link ${isActive('/contact') ? 'active' : ''}`}
                onClick={() => setIsMenuOpen(false)}
              >
                <FaEnvelope className="nav-icon" /> 
                <span className="nav-text">Contact</span>
              </Link>
            </li>
            
            {user ? (
              <>
                <li>
                  <Link 
                    to="/dashboard" 
                    className={`nav-link ${isActive('/dashboard') ? 'active' : ''}`}
                    onClick={() => setIsMenuOpen(false)}
                  >
                    <FaUser className="nav-icon" /> 
                    <span className="nav-text">Dashboard</span>
                  </Link>
                </li>
                {userData?.userType === 'admin' && (
                  <li>
                    <Link 
                      to="/admin" 
                      className={`nav-link ${isActive('/admin') ? 'active' : ''}`}
                      onClick={() => setIsMenuOpen(false)}
                    >
                      <FaChalkboardTeacher className="nav-icon" /> 
                      <span className="nav-text">Admin Panel</span>
                    </Link>
                  </li>
                )}
                <li className="nav-action">
                  <button onClick={handleLogout} className="btn btn-outline logout-btn">
                    <FaSignOutAlt className="btn-icon" /> 
                    <span>Logout</span>
                  </button>
                </li>
                <li className="user-info">
                  <span className="user-greeting">
                    Hi, {userData?.fullName?.split(' ')[0] || 'User'}!
                  </span>
                </li>
              </>
            ) : (
              <>
                <li className="nav-action">
                  <Link 
                    to="/login" 
                    className="btn btn-outline" 
                    onClick={() => setIsMenuOpen(false)}
                  >
                    <span>Login</span>
                  </Link>
                </li>
                <li className="nav-action">
                  <Link 
                    to="/register" 
                    className="btn btn-primary" 
                    onClick={() => setIsMenuOpen(false)}
                  >
                    <span>Sign Up</span>
                  </Link>
                </li>
              </>
            )}
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Navbar;